import { createSlice } from '@reduxjs/toolkit'

export const callErrorTypes = Object.freeze({
    NONE: 0,
    GENERIC: 1,
    CARRIERBLOCKED: 2,
    CALLDECLINED: 3,
})

export const callSlice = createSlice({
    name: 'call',
    initialState: {
        call: [],
        ringState:'disconnected',
        sessionStarted:false,
        callErrorType: callErrorTypes.NONE,
        callErrorMessage: '',
        callErrorSolutions: []
    },
    reducers: {
        setCall(state, action) {
            state.call = action.payload;
        },
        setStartSession(state, action) {
            state.sessionStarted = action.payload;
        },
        setRingState(state, action) {
            state.ringState = action.payload;
        },
        captureCallError(state, action) {
            const {errorCode, errorMessage, errorSolutions = []} = action.payload

            switch (errorCode) {
                case 32017:
                    state.callErrorType = callErrorTypes.CARRIERBLOCKED
                    state.callErrorMessage = 'Carrier blocked call due to caller ID reputation. This occurs when the calling number has a poor reputation score, often due to high volumes of unwanted calls or low answer rates.'
                case 31603:
                    state.callErrorType = callErrorTypes.CALLDECLINED
                    state.callErrorMessage = 'Decline. The call was explicitly declined by the endpoint or its carrier. This could be due to the user declining the call or the carrier rejecting it for various reasons.'
                    break
                default:
                    state.callErrorType = callErrorTypes.GENERIC
                    state.callErrorMessage = errorMessage
                    break
            }

            state.callErrorSolutions = errorSolutions
        },
        resetCallError(state) {
            state.callErrorType = callErrorTypes.NONE
            state.callErrorMessage = ''
            state.callErrorSolutions = []
        }
    },
})
export const { setCall, setRingState,setStartSession, captureCallError, resetCallError } = callSlice.actions;

export default callSlice.reducer

